module.exports = __webpack_public_path__ + "img/traffic1.73f17a7c.png";